import L from 'leaflet';

export function communityMap() {
	const el = document.getElementById('community-map');
	if (!el || !window.communityMarkers) return;

	const markers = window.communityMarkers;
	const map = L.map('community-map', { scrollWheelZoom: false }).setView([39.5, -80], 6);

	L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
		maxZoom: 18,
	}).addTo(map);

	// Custom green marker icon
	const icon = L.divIcon({
		className: 'community-marker',
		html: '<svg width="28" height="40" viewBox="0 0 28 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 0C6.268 0 0 6.268 0 14c0 10.5 14 26 14 26s14-15.5 14-26C28 6.268 21.732 0 14 0z" fill="#517330"/><circle cx="14" cy="14" r="6" fill="#fff"/></svg>',
		iconSize: [28, 40],
		iconAnchor: [14, 40],
		popupAnchor: [0, -36],
	});

	const markerLayer = L.featureGroup();

	markers.forEach((m) => {
		const popup = `
			<strong>${m.name}</strong><br>
			${m.location}<br>
			<span style="color:#517330;font-size:0.875rem">${m.careType}</span><br>
			<a href="${m.url}" target="_blank" rel="noopener">Learn More &rarr;</a>
		`;
		const marker = L.marker([m.lat, m.lng], { icon })
			.bindPopup(popup)
			.addTo(markerLayer);
		marker._data = m;
	});

	markerLayer.addTo(map);
	map.fitBounds(markerLayer.getBounds().pad(0.15));

	// Expose for filter syncing
	window._communityMap = { map, markerLayer };
}
